import { PAGE_SIZE } from 'src/pages/worldCup2026/const'
import { ListRequest } from 'src/pages/worldCup2026/types'

export const buildQuery = (params: ListRequest) => {
  const arrayFields = ['taskType', 'prizeType', 'level']
  const keyMap: Record<string, string> = {
    'client.clientId': 'client.id',
  }

  let { limit = PAGE_SIZE, page = 1, orderBy, orderDirection, filters } = params

  const query: Record<string, any> = { limit, page }
  const normalizedOrderDirection = orderDirection === 'descend' ? '-' : ''

  if (orderBy) {
    query['order'] = normalizedOrderDirection + orderBy
  }

  let whereObj: Record<string, any> = {}

  if (filters && Object.keys(filters).length) {
    whereObj = Object.fromEntries(
      Object.entries(filters)
        .filter(([_, value]) => Boolean(value))
        .map(([key, value]) => {
          const mappedKey = keyMap[key] ?? key

          const mappedValue = arrayFields.includes(key)
            ? value
            : String(value).toLowerCase()

          return [mappedKey, mappedValue]
        }),
    )
  }

  if (Object.keys(whereObj).length !== 0) {
    query['where'] = JSON.stringify(whereObj)
  }

  return { query }
}

export const filterOption = (
  inputValue: string,
  option?: { label?: string },
) => {
  if (!option?.label) return false
  return option.label.toLowerCase().includes(inputValue.trim().toLowerCase())
}
